import axios from 'axios';

const inferApiBase = () => {
  const envValue = process.env.REACT_APP_API_BASE_URL;
  if (envValue && typeof envValue === 'string' && envValue.trim().length > 0) {
    return envValue.trim().replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location) {
    const { protocol, hostname } = window.location;
    const basePort = 8000;
    return `${protocol}//${hostname}:${basePort}`;
  }

  return 'http://127.0.0.1:8000';
};

const API_BASE = inferApiBase();

export const api = axios.create({ baseURL: API_BASE });

api.defaults.withCredentials = true;


export const authApi = {
  async login(email, password, remember = false) {
    const response = await api.post('/api/customer/login', { email, password, remember });
    return response.data;
  },
  async logout() {
    const response = await api.post('/api/customer/logout');
    return response.data;
  },
  async check() {
    const response = await api.get('/api/customer/check');
    return response.data;
  },
};


export default function useApi() {
  return { api };
}